import { Box, BoxProps } from '@chakra-ui/react';
import { Colors, Text } from '@mercator-gcp/grout';
import { EmptyField } from 'components/elements/EmptyField';
import type { Activity } from 'types';

type Props = BoxProps & {
  status: Activity['status'];
};

export const StatusChip = ({ status, ...props }: Props) => {
  const isCompleted = ['released', 'completed'].includes(status.toLowerCase());

  const container = {
    color: isCompleted ? Colors.ForestGreen900 : Colors.Black800,
    textTransform: 'capitalize',
  };

  return (
    <Box sx={container} {...props}>
      {status ? <Text.Small>{status}</Text.Small> : <EmptyField />}
    </Box>
  );
};
